import { PAYROLL_MODEL_IDS, PayrollModelId } from '@xemplo/gp-types';

import {
  MilestoneFieldConfig,
  MilestoneFieldKey,
  MilestoneGroupConfig,
} from './edit-payrun-milestones.types';

export const MILESTONE_GROUPS: MilestoneGroupConfig[] = [
  {
    title: 'Amendments',
    fields: [
      {
        key: 'amendmentDue',
        label: 'Amendments due',
        source: 'amendmentDueDateTime',
      },
    ],
  },
  {
    title: 'Preparation',
    fields: [
      {
        key: 'preparationDue',
        label: 'Preparing Pay Run',
        source: 'preparationDueDateTime',
      },
      {
        key: 'approvalDue',
        label: 'Review & Approve',
        source: 'approvalDueDateTime',
      },
    ],
  },
  {
    title: 'Finalisation',
    fields: [
      {
        key: 'finaliseDue',
        label: 'Finalisation Due',
        source: 'finaliseDueDateTime',
      },
      {
        key: 'paymentDue',
        label: 'Payment Due',
        source: 'paymentDueDateTime',
      },
    ],
  },
  {
    title: 'Pay Cycle',
    fields: [
      {
        key: 'payDateTime',
        label: 'Pay Date',
        source: 'payDate',
      },
      {
        key: 'payCycleStart',
        label: 'Pay Cycle Start',
        source: 'payCycleStartDate',
        dateOnly: true,
      },
      {
        key: 'payCycleEnd',
        label: 'Pay Cycle End',
        source: 'payCycleEndDate',
        dateOnly: true,
      },
    ],
  },
];

export const MILESTONE_FIELDS: MilestoneFieldConfig[] = MILESTONE_GROUPS.flatMap(
  (group) => group.fields,
);

/** Payment Due is hidden for Outsource pay runs; PEO sees every milestone. */
function isFieldVisible(key: MilestoneFieldKey, payrollModelId: PayrollModelId): boolean {
  return key !== 'paymentDue' || payrollModelId !== PAYROLL_MODEL_IDS.OUTSOURCE;
}

/** Milestone groups visible for the given payroll model. */
export function getMilestoneGroups(
  payrollModelId: PayrollModelId,
): MilestoneGroupConfig[] {
  return MILESTONE_GROUPS.map((group) => ({
    ...group,
    fields: group.fields.filter((field) => isFieldVisible(field.key, payrollModelId)),
  }));
}

/** Flat list of milestone fields visible for the given payroll model. */
export function getMilestoneFields(
  payrollModelId: PayrollModelId,
): MilestoneFieldConfig[] {
  return getMilestoneGroups(payrollModelId).flatMap((group) => group.fields);
}
